import React, { Fragment, useContext, useEffect, useState } from "react";
import {
    Row,
    Col,
    CardBody,
    CardHeader,
    Nav,
    NavItem,
    TabContent,
    TabPane,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import Update from './Update';
import { useAppContext } from "../../context";
import Card from "../custom/Card";
import PDFViewer from "../PDFViewerOld";
import { Newsletter } from "../../globals/interfaces";
import styled from "styled-components";
import { Input } from "reactstrap";

export default function RenderNewsletters() {

    const { newsletters } = useAppContext();
    const [selectedNewsletter, setSelectedNewsletter] = useState('');

    useEffect(() => {
        if (newsletters.length) {
            setSelectedNewsletter(newsletters[0].link);
        }
    }, [newsletters]);

    return (
        <div>
            <FlexContainer>
                <h6>Newsletter</h6>
                <CustomInput type={'select'} onChange={(e) => setSelectedNewsletter(e.target.value)}>
                    {
                        newsletters.map((item, i) => (
                            <option key={i} value={item.link}>{item.year} {item.issue}: {item.name}</option>
                        ))
                    }
                </CustomInput>
            </FlexContainer>
            {
                (newsletters.length && selectedNewsletter) ? (
                    <iframe
                        src={`${selectedNewsletter}#zoom=page-fit`}
                        width="100%"
                        height="1000px"
                        style={{ border: 'none' }}
                        title="PDF Viewer"
                    />
                ) : null
            }
        </div>
    );
}


const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
`;

const CustomInput = styled(Input)`
    width: 70%;
`;